/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { SponsoredCompanyRow, getSubscriptionEndDate, getSubscriptionStartDate, pcComplete } from '../utils';
import Chart from 'react-google-charts';

export const GanttChart = (props: SponsoredCompanyRow) => {
  const { subscriptions } = props;

  const TRACK_HEIGHT = 40;
  const columns = [
    { type: 'string', label: 'ID' },
    { type: 'string', label: 'Type' },
    { type: 'string', label: 'Resource' },
    { type: 'date', label: 'Start Date' },
    { type: 'date', label: 'End Date' },
    { type: 'number', label: 'Duration' },
    { type: 'number', label: 'Percent Complete' },
    { type: 'string', label: 'Dependencies' },
  ];

  const now = Date.now() / 1000;
  const rows: (string | Date | null | number)[][] = [];
  subscriptions.forEach(sub => {
    // The idea is to show a full period of subscription until it ends.
    // However, if there is a 1 year sponsorship, the period end will always be at the
    // end of the rolling month, so we can assume it will continue until the sponsorship end
    // In which case instead of showing the subscription, we show the sponsorship end
    const subStart = getSubscriptionStartDate(sub);
    const subEnd = getSubscriptionEndDate(sub);
    if (subEnd > now && sub.discount) {
      // Only show sponsorships if they impact the current period
      rows.push([
        sub.discount.id,
        'Sponsored Subscription',
        sub.id,
        new Date(subStart * 1000),
        new Date((sub.discount.end ?? subEnd) * 1000),
        null,
        pcComplete(subStart, sub.discount.end ?? subEnd, now),
        null
      ]);
    } else {
      rows.push([
        sub.id,
        'Subscription',
        sub.id,
        new Date(subStart * 1000),
        new Date(subEnd * 1000),
        null,
        pcComplete(subStart, subEnd, now),
        null
      ]);
    }
  });

  return (
    <Chart
      chartType='Gantt'
      width='100%'
      height={(subscriptions.length * TRACK_HEIGHT) + 80}
      data={[columns, ...rows]}
      options={{
        gantt: {
          labelStyle: {
            fontName: 'Arial',
          },
          TRACK_HEIGHT
        }
      }}
    />
  );
}
